import React from 'react'
import StatusLight from '../../../components/Status/StatusLight'

const NoEntryIntoTheUsageUnitWithoutEquipmentStatusRenderer = (props) => {
  return <StatusLight status='error' size='16px' />
}

export default NoEntryIntoTheUsageUnitWithoutEquipmentStatusRenderer
